import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const BrandingCtx = createContext(null);

const DEFAULT = {
  logo_url: null,
  logo_version: "",
  logo_alt: "Eira",
  tagline: "Goodness Lives Here",
  contact_mobile: "",
  contact_email: "",
  address: "",
  socials: {
    facebook: { url: "", enabled: false },
    instagram: { url: "", enabled: false },
    youtube: { url: "", enabled: false },
    website: { url: "", enabled: false },
  },
};

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(DEFAULT);
  const [loading, setLoading] = useState(true);
  const refresh = () => {
    setLoading(true);
    return api.get("/branding")
      .then((r) => setBranding({ ...DEFAULT, ...r.data, socials: { ...DEFAULT.socials, ...(r.data.socials || {}) } }))
      .catch(() => {})
      .finally(() => setLoading(false));
  };
  useEffect(() => { refresh(); }, []);
  const versionedLogoUrl = branding.logo_url && branding.logo_version
    ? `${branding.logo_url}${branding.logo_url.includes("?") ? "&" : "?"}v=${branding.logo_version}`
    : branding.logo_url;

  useEffect(() => {
    const iconUrl = branding.favicon_url || versionedLogoUrl;
    if (!iconUrl) return;
    let icon = document.querySelector("link[rel~='icon']");
    if (!icon) {
      icon = document.createElement("link");
      icon.rel = "icon";
      document.head.appendChild(icon);
    }
    icon.href = iconUrl;
  }, [branding.favicon_url, versionedLogoUrl]);
  return <BrandingCtx.Provider value={{ ...branding, logo_url: versionedLogoUrl, loading, refresh }}>{children}</BrandingCtx.Provider>;
};

export const useBranding = () => useContext(BrandingCtx) || { ...DEFAULT, refresh: () => {} };
